import { Form, Input } from "@arco-design/web-react"
import { useEffect } from "react";

const FormItem = Form.Item;

export const ContactInfo = ({ value, onChange }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        const values = { ...value }
        form.setFieldsValue(values);
    }, [form, value]);

    const handleFormChange = () => {
        const values = form.getFieldsValue();
        onChange?.({ ...value, ...values });
    };

    return (
        <Form form={form} colon
            onChange={handleFormChange}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 5 }}>
            <FormItem label="First Name" field="contactFirstName" required rules={[{ required: true }]}>
                <Input />
            </FormItem>
            <FormItem label="Last Name" field="contactLastName" required rules={[{ required: true }]}>
                <Input />
            </FormItem>
            <FormItem label="Email" field="contactEmail" required rules={[{ required: true }]}>
                <Input />
            </FormItem>
        </Form>
    );
}